import GridDuck from 'gridduck';

const isOnlyTopLevelAssetInSite = (a, assets) => {
    const sameSiteTopLevelAssets = assets.filter(
        other => other.siteId === a.siteId && !other.parentAsset
    );
    return sameSiteTopLevelAssets.length === 1;
};

const isDifferentOrOrphaned = function (a, assets) {
    const normalise = (lt) =>
        lt == null || lt === 0 || lt === 2 ? 'consumption' : 'generation';

    const hasParent = !!a.parentAsset && assets.some(as => as.id === a.parentAsset);
    const parentMissing = !!a.parentAsset && !hasParent;

    let parentA;
    if (!parentMissing) {
        parentA = assets.find(as => as.id === a.parentAsset);
    }

    const differentLoadType = normalise(parentA?.loadType) !== normalise(a.loadType);

    // New logic for filtering top-level devices on hierarchical sites
    const sameSiteAssets = assets.filter(as => as.siteId === a.siteId);
    const siteIsFlat = !sameSiteAssets.some(as => !!as.parentAsset);
    const isTopLevel = !a.parentAsset;

    // Only hide top-level device if site has hierarchy
    const shouldHideDueToHierarchy = !siteIsFlat && isTopLevel;

    return parentMissing || differentLoadType || shouldHideDueToHierarchy;
};


const apiFilterByGraphType = function(filterType) {
    let filterBy;
    if (filterType === 'site_group_id') filterBy = 'siteGroupId';
    if (filterType === 'site_id') filterBy = 'siteId';
    if (filterType === 'group_id') filterBy = 'groupId';
    if (filterType === 'org_partner_id') filterBy = 'orgPartnerId';
    return filterBy;
}

const getAssetsFilteredForGraph = async function(props, filter) {
    let filterBy = apiFilterByGraphType(props.filterType);

    const siteGroup = await GridDuck.getAssets({
        filters: [{
            field: filterBy,
            value: props.filterId
        }, {
            field: 'assetId',
            value: "filtered"
        }], getAll: true
    });
    if (filter) {
        return siteGroup.list.filter(a => !isDifferentOrOrphaned(a, siteGroup.list));
    } else {
        return siteGroup.list;
    }
}

export default getAssetsFilteredForGraph